const parseVersion = (version: string) =>
  version.split('.').map(part => parseInt(part, 10) || 0);

export const isVersionAtLeast = (
  version: string | undefined,
  minVersion: string,
) => {
  if (!version) return false;

  const current = parseVersion(version);
  const min = parseVersion(minVersion);
  const length = Math.max(current.length, min.length);

  for (let i = 0; i < length; i++) {
    const currentPart = current[i] ?? 0;
    const minPart = min[i] ?? 0;

    if (currentPart !== minPart) return currentPart > minPart;
  }

  return true;
};
